import type { ReactNode } from 'react';

import { ViewPlaceholder } from './ViewPlaceholder';

export interface ViewStringProps {
  readonly value: string | null | undefined;
  /** Shown, muted, when there is no value; e.g. "Any node" where empty means a wildcard. */
  readonly placeholder?: ReactNode;
  /** Render as code: for an expression or a raw value, not prose. */
  readonly code?: boolean;
}

export const ViewString = ({ value, placeholder, code = false }: ViewStringProps) => {
  if (value === null || value === undefined || value === '') return <ViewPlaceholder placeholder={placeholder} />;
  return code ? <code>{value}</code> : <>{value}</>;
};
